type ProductTypeHierarchyFields = {
  productType?: string;
  foodType?: string;
  category?: string;
  segment?: string;
  platform?: string;
  menuItemName?: string;
};

export const mapProductTypeHierarchyToAnalyticsFields = (
  productTypeHierarchy?: readonly string[] | null
): ProductTypeHierarchyFields => ({
  productType: productTypeHierarchy?.[0],
  foodType: productTypeHierarchy?.[1],
  category: productTypeHierarchy?.[2],
  segment: productTypeHierarchy?.[3],
  platform: productTypeHierarchy?.[4],
  menuItemName: productTypeHierarchy?.[5],
});
